export default __webpack_public_path__ + "static/media/conversation.7d746c46.svg";